import { render, staticRenderFns } from "./submission.vue?vue&type=template&id=60b36281&scoped=true&"
import script from "./submission.vue?vue&type=script&lang=js&"
export * from "./submission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b36281",
  null
  
)

export default component.exports